import makeStyles from "@mui/styles/makeStyles";

import { relativeCTABackgrounds } from "utils/relativeUtils";

export default makeStyles(
  (theme) => ({
    paper: {
      width: 260,
      minHeight: 450,
      padding: [44, 26, 28],
      position: "relative",
      borderRadius: 10,
    },
    buttonClose: {
      padding: 0,
      position: "absolute",
      right: 20,
      top: 20,
      width: 24,
      height: 24,
      fontSize: theme.typography.pxToRem(12),
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    figure: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: 20,
    },
    image: {
      maxWidth: 128,
      maxHeight: 128,
      objectFit: "scale-down",
    },
    title: {
      marginBottom: 19,
    },
    description: {
      marginBottom: 28,
    },
    ...relativeCTABackgrounds(theme),
  }),
  { name: "CTAModal" },
);
